import { FormEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthLayout } from '../../components/auth/AuthLayout';
import { FormError, SubmitButton, TextField } from '../../components/auth/FormFields';
import { authApi, readApiError } from '../../lib/auth-api';

export function ForgotPasswordPage() {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setErr(null);
    try {
      await authApi.forgotPassword(email);
      setSent(true);
    } catch (e) {
      setErr(readApiError(e, t('auth.errorGeneric')));
    } finally {
      setBusy(false);
    }
  }

  if (sent) {
    return (
      <AuthLayout
        eyebrow={t('auth.forgotEyebrow')}
        title={t('auth.forgotCheckTitle')}
        subtitle={t('auth.forgotCheckBody', { email })}
        altCta={{ to: '/login', helper: t('auth.backTo'), label: t('auth.signInLink') }}
      >
        <button
          type="button"
          onClick={() => setSent(false)}
          className="w-full inline-flex items-center justify-center h-11 rounded-lg border border-border bg-card text-sm font-medium hover:bg-muted"
        >
          {t('auth.useDifferentEmail')}
        </button>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout
      eyebrow={t('auth.forgotEyebrow')}
      title={t('auth.forgotTitle')}
      subtitle={t('auth.forgotSubtitle')}
      altCta={{ to: '/login', helper: t('auth.backTo'), label: t('auth.signInLink') }}
    >
      <form onSubmit={onSubmit} className="space-y-4">
        <TextField
          label={t('common.email')}
          type="email"
          autoComplete="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        {err && <FormError>{err}</FormError>}
        <SubmitButton loading={busy}>{t('auth.forgotButton')}</SubmitButton>
      </form>
    </AuthLayout>
  );
}
